import { render, staticRenderFns } from "./WhatsAppContactItem.vue?vue&type=template&id=9d89487a&scoped=true&"
import script from "./WhatsAppContactItem.vue?vue&type=script&lang=js&"
export * from "./WhatsAppContactItem.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppContactItem.vue?vue&type=style&index=0&id=9d89487a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d89487a",
  null
  
)

export default component.exports